import React from 'react';
import { Reseller, ResellerImage } from "../../shared/resellers";
import Image from "../Image";
import { MapDotIcon } from "../icons";
import { createUseThemedStyles } from "../../hooks/createUseThemedStyles";
import { Markup } from "../Typography";
import { AiFillPhone } from 'react-icons/ai';

type Props = {
  reseller: Reseller;
  onClick: (reseller: Reseller) => void;
}

const useStyles = createUseThemedStyles(theme => ({
  reseller: {
    display: 'flex',
    alignItems: 'stretch',
    justifyContent: 'space-between',
    gap: 20,
    paddingTop: 20,
    paddingBottom: 20,
    borderTop: `0.5px solid ${theme.color.grayLine}`,
    cursor: 'pointer',
  },
  resellerContent: {
    width: '50%',
    flex: '0 0 50%',
  },
  resellerImage: {
    width: 'calc(45% - 20px)',
    flex: '0 0 calc(45% - 20px)',
    display: 'flex',
    flexWrap: 'wrap',
    alignContent: 'space-around',
    '& img': {
      height: '100%',
      objectFit: 'cover',
    },
    '& span': {
      height: 'auto'
    }
  },
  resellerTitle: {
    fontFamily: theme.fonts.heading,
    color: theme.color.grayText,
    fontStyle: 'italic',
    fontSize: 27,
    margin: 0,
    fontWeight: 400,
  },
  resellerCategory: {
    color: theme.color.primary,
    fontSize: 10,
    fontWeight: 700,
    textTransform: 'uppercase',
    margin: [0, 0, 12],
  },
  contactsLine: {
    color: theme.color.grayMask,
    fontSize: 13,
    fontWeight: 300,
    lineHeight: '16px',
    margin: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '&:last-child': {
      marginTop: 12,
    },
    '& svg': {
      marginLeft: theme.spacing.medium,
      width: 14,
      minWidth: 14,
      '& path': {
        fill: '#CDCDCD',
      }
    }
  },
}));

const ResellerPreview: React.FC<Props> = ({ reseller, onClick }) => {
  const image = (reseller.field_revender_image?.length ? reseller.field_revender_image[0] : {}) as ResellerImage;
  const styles = useStyles();
  return (
    <article
      className={styles.reseller}
      onClick={() => onClick(reseller)}
    >
      <div className={styles.resellerContent}>
        <div className={styles.resellerBlockTitle}>
          <h3 className={styles.resellerTitle}>{reseller.title}</h3>
          <Markup className={styles.resellerCategory} html={reseller.field_revender_category} />
        </div>
        <div className={styles.contactsLine}>
          {reseller.field_address_line_1}
          {reseller.field_address_line_2 ? null : <MapDotIcon />}
        </div>
        {reseller.field_address_line_2 && (
          <div className={styles.contactsLine}>
            {reseller.field_address_line_2}
            <MapDotIcon />
          </div>
        )}
        {reseller.field_revender_telephone && (
          <div className={styles.contactsLine}>
            {reseller.field_revender_telephone}
           <AiFillPhone />
          </div>
        )}
      </div>
      <Image className={styles.resellerImage} src={image.image_url} alt={image.image_alt} />
    </article>
  )
}

export default ResellerPreview;

